import { IonButton, IonCol, IonIcon, IonRow, IonSpinner, IonText } from "@ionic/react";
import { checkmarkCircleOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { useHistory, useLocation } from "react-router";
import "./Template.css";

interface Template {
  id: number;
  image: StringConstructor;
  preview: string;
}

interface Props {
  type: "gift" | "tree";
  donator: string,
  giftName: string,
  memorial: string,
  templates: Template[];
  templateId: number;
  setTemplateId: React.Dispatch<React.SetStateAction<number>>;
}

const Templates: React.FC<Props> = (props) => {
  const history = useHistory();
  const location = useLocation();

  const [selectedPreviewId, setSelectedPreviewId] = useState(0);
  const [previewShowLoading, setPreviewShowLoading] = useState(false);

  useEffect(() => {
    console.log(props.templates);

    const handleHashChange = () => {
      if (!location.hash) {
        setSelectedPreviewId(0);
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  useEffect(() => {
    if (props.templates != undefined && props.templates?.length > 0) {
      props.setTemplateId(props.templates![0]!.id!);
    }
  }, [props.templates]);

  const templateChangeHandler = (item: any) => {
    props.setTemplateId(item.id);
  };

  const showPreview = (id: number) => {
    setSelectedPreviewId(id);
    setPreviewShowLoading(true);
    history.push(`${location.pathname}#preview-${id}`);
  };

  return (
    <>
      <IonRow className="donation-templates">
        <IonCol size="12">
          <p className="ion-text-right">{props.type == "gift" ? "انتخاب طرح کارت" : "انتخاب طرح سند"}</p>
        </IonCol>
        {props.templates?.map((item: any, index: number) => {
          return (
            <IonCol size="4">
              <div
                onClick={() => templateChangeHandler(item)}
                style={{background: 'url( ' + item.image + ')'}}
                className={`${
                  item.id == props.templateId || (props.templateId == 0 && index == 0)
                    ? "donation-template-item donation-template-checked"
                    : "donation-template-item"
                }`}
              >
                <p className="donation-template-title">{item.title}</p>
                <IonButton expand="block" className="donation-template-preview" onClick={(e) => { e.stopPropagation(); showPreview(item.id) }}>
                  <IonText>پیش نمایش</IonText>
                </IonButton>
                <IonIcon src={checkmarkCircleOutline} />
              </div>
            </IonCol>
          );
        })}
      </IonRow>
      <Modal
        open={selectedPreviewId != 0}
        onClose={() => {
          history.goBack();
          setSelectedPreviewId(0);
        }}
        center
        showCloseIcon={false}
        classNames={{ modalContainer: "donation-template-preview-modal" }}
      >
        <div className="donation-template-preview-container">
          {previewShowLoading && <IonSpinner name="crescent" className=""></IonSpinner>}
          {props.templates
            ?.filter((item: any) => item.id == selectedPreviewId)
            .map((item: any) => {
              return <img src={item.preview + "?donator=" + encodeURIComponent(props.donator) + "&gift_name=" + encodeURIComponent(props.giftName) + "&memorial=" + encodeURIComponent(props.memorial)} onLoad={() => setPreviewShowLoading(false)} />;
            })}
        </div>
      </Modal>
    </>
  );
};

export default Templates;
